'use client';

import { TolgeeProvider as TolgeeProviderBase } from '@tolgee/react';
import { type ReactNode } from 'react';

import { tolgee } from '@/lib/tolgee';

interface TolgeeProviderProps {
  children: ReactNode;
}

export function TolgeeProvider({ children }: TolgeeProviderProps) {
  // DevTools visibility is controlled by NEXT_PUBLIC_TOLGEE_DEV_TOOLS environment variable
  return <TolgeeProviderBase tolgee={tolgee}>{children}</TolgeeProviderBase>;
}
